exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "subscription table>tbody td,subscription table>tbody th{border:unset!important}subscription .form-signin{margin-top:3rem;margin-bottom:3rem;display:inline-grid;width:330px;padding:30px 15px}subscription .m-a{margin:0 auto}subscription .pr-4px{padding-right:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/app/pages/subscription/subscription.scss
// module id = 1280
// module chunks = 0